import { render, staticRenderFns } from "./ProductOption.vue?vue&type=template&id=01f2b44e&scoped=true&"
import script from "./ProductOption.vue?vue&type=script&lang=ts&"
export * from "./ProductOption.vue?vue&type=script&lang=ts&"
import style0 from "./ProductOption.vue?vue&type=style&index=0&id=01f2b44e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f2b44e",
  null
  
)

export default component.exports